import { Navigate, useOutlet } from "react-router-dom";

export const AuthLayout = () => {
  const user = JSON.parse(localStorage.getItem("user_data_admin"));
  const outlet = useOutlet();

  if (user) {
    return <Navigate to="/" />;
  }

  return <div>{outlet}</div>;
};
